import * as React from 'react';
import styled from 'styled-components';
import Colors from '../../lib/Colors';
import { IProfile } from '../../lib/types/Profile';
import padStart from './padStart';

const monthNames = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
];

interface IProps {
  profile: IProfile & { year?: string, month?: string, day?: string };
  onChange?: (e: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => void;
  className?: string;
}

function UnstyledAddressForm(props: IProps) {
  const { day, month, year } = props.profile;

  const dayNumbers = Array.from({ length: 31 }).map((_, i) => padStart(String(i + 1), 2, '0'));
  const monthNumbers = Array.from({ length: 12 }).map((_, i) => padStart(String(i + 1), 2, '0'));
  const minimalYear = 1900;
  const maximalYear = 2005;
  const yearNumbers = Array.from({ length: maximalYear - minimalYear })
    .map((_, i) => i + minimalYear);

  return (
    <form className={props.className}>
      <section>
        <select
          name="gender"
          placeholder="Anrede"
          value={props.profile.gender || ''}
          onChange={props.onChange}
          style={{ width: '5rem', marginRight: '.5rem' }}
          required={true}
        >
          <option value="" disabled={true}>Anrede</option>
          <option value="male">Herr</option>
          <option value="female">Frau</option>
        </select>

        <input
          name="firstName"
          placeholder="Vorname"
          value={props.profile.firstName || ''}
          onChange={props.onChange}
          style={{ flex: 1 }}
          required={true}
        />

        <input
          name="lastName"
          placeholder="Nachname"
          value={props.profile.lastName || ''}
          onChange={props.onChange}
          style={{ flex: 1 }}
          required={true}
        />
      </section>

      {/* <section>
        <input
          name="nickname"
          placeholder="Nickname"
          value={props.profile.nickname}
          onChange={props.onChange}
          style={{ flex: 1 }}
        />
      </section> */}

      <section>
        <input
          name="street"
          placeholder="Straße"
          value={props.profile.street || ''}
          onChange={props.onChange}
          style={{ flex: 1 }}
          required={true}
        />
      </section>

      <section>
        <input
          name="postalCode"
          placeholder="PLZ"
          value={props.profile.postalCode || ''}
          onChange={props.onChange}
          style={{ width: '5rem', marginRight: '.5rem' }}
          required={true}
        />
        <input
          name="city"
          placeholder="Ort"
          value={props.profile.city || ''}
          onChange={props.onChange}
          style={{ flex: 1 }}
          required={true}
        />
      </section>

      <section>
        <header style={{ width: '100%', margin: '0.25em 0.5rem' }}>
          Dein Geburtstag:
        </header>
        <select
          name="day"
          placeholder="Tag"
          value={day || ''}
          onChange={props.onChange}
          style={{ width: '5rem', marginRight: '.5rem' }}
          required={true}
        >
          <option value="" disabled={true}>Tag</option>
          {dayNumbers.map(d => <option value={d} key={d}>{parseInt(d, 10)}.</option>)}
        </select>
        <select
          name="month"
          placeholder="Tag"
          value={month || ''}
          onChange={props.onChange}
          style={{ width: '5rem', marginRight: '.5rem' }}
          required={true}
        >
          <option value="" disabled={true}>Monat</option>
          {monthNumbers.map(d => <option value={d} key={d}>
            {monthNames[parseInt(d, 10) - 1]}
          </option>)}
        </select>
        <select
          name="year"
          placeholder="Tag"
          value={year || ''}
          onChange={props.onChange}
          style={{ width: '5rem', marginRight: '.5rem' }}
          required={true}
        >
          <option value="" disabled={true}>Jahr</option>
          {yearNumbers.map(d => <option value={d} key={d}>{d}</option>)}
        </select>
      </section>
    </form>
  );
}

const AddressForm = styled(UnstyledAddressForm)`
  padding: 0.5rem;

  * {
    box-sizing: border-box;
  }

  select, input {
    appearance: none;
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    border: none;
    background-color: transparent;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, .3);
    border-radius: 2px;
    height: 2rem;
    transition: box-shadow 0.3s ease-out;

    :invalid {
      box-shadow: 0 0 0 1px ${Colors.error};
      color: ${Colors.error};
      ::placeholder {
        color: ${Colors.error};
      }
    }

    :focus {
      border: none;
      outline: none;
      box-shadow: 0 0 0 4px rgba(55, 181, 234, 0.48);
      :invalid {
        box-shadow: 0 0 0 4px ${Colors.error};
      }
    }

    margin: 0.25rem;
  }

  img {
    margin: 0.5em auto;
    display: flex;
  }

  > section {
    display: flex;
    flex-wrap: wrap;
    border: none;
    margin: 0;
  }
`;

export default AddressForm;



// WEBPACK FOOTER //
// ./src/components/AddressEditor/AddressForm.tsx